import { useMemo } from "react";
import { Button, Paper, Popper, useTheme } from "@mui/material";
import Columns from "../../../library/components/layout/Columns";
import { PDF_ANNOTATION_COLOR_GROUPS } from "./pdfCanvasConstants";
import type { PdfCanvasMarkHoverState } from "./pdfCanvasTypes";

interface IPdfCanvasMarkColorPopoverProps {
    hoveredMark: PdfCanvasMarkHoverState | null,
    onSelectColor: (mark: PdfCanvasMarkHoverState, renkKod: string) => void,
    onMouseEnter: () => void,
    onMouseLeave: () => void,
}

/** İşaretin üzerine gelince mouse'un yanında açılan renk paneli; seçilen renk yalnız o işarete uygulanır. */
const PdfCanvasMarkColorPopover = (props: IPdfCanvasMarkColorPopoverProps) => {
    const theme = useTheme();
    const mark = props.hoveredMark;

    const anchorEl = useMemo(() => mark === null ? null : {
        getBoundingClientRect: () => new DOMRect(mark.clientX, mark.clientY, 0, 0),
    }, [mark]);

    return <Popper
        open={mark !== null}
        anchorEl={anchorEl}
        placement="top-start"
        modifiers={[{ name: "offset", options: { offset: [8, 10] } }]}
        style={{ zIndex: theme.zIndex.tooltip }}
    >
        {mark === null ? null
            : <Paper
                elevation={6}
                onMouseEnter={props.onMouseEnter}
                onMouseLeave={props.onMouseLeave}
                style={{ borderRadius: 8 }}
            >
                <Columns gap={10} p={6} style={{ alignItems: "center" }}>
                    {PDF_ANNOTATION_COLOR_GROUPS.map(group =>
                        <Columns key={group.groupName} gap={4} style={{ alignItems: "center" }}>
                            {group.items.map(item =>
                                <Button
                                    key={item.color}
                                    onClick={() => props.onSelectColor(mark, item.color)}
                                    title={`${group.groupName}: ${item.label}`}
                                    style={{
                                        minWidth: 24,
                                        width: 24,
                                        height: 24,
                                        borderRadius: "50%",
                                        border: mark.stroke.color === item.color ? "2px solid black" : "1px solid #ccc",
                                        background: item.color,
                                    }}
                                />
                            )}
                        </Columns>
                    )}
                </Columns>
            </Paper>}
    </Popper>;
};

export default PdfCanvasMarkColorPopover;
